import bind from 'bind-decorator';
import React from 'react';
import { Entity } from 'tm2-draft-js';
import Group from '../../draft/entities/group';

class DraftBase<T> extends React.Component<T> {
  styleMap: Record<string, React.CSSProperties> = {
    'colour-red': { color: 'rgba(255, 0, 0, 1.0)' },
    'colour-blue': { color: 'rgba(0, 0, 255, 1.0)' },
    'colour-black': { color: 'rgba(0, 0, 0, 1.0)' },
    'colour-green': { color: 'rgba(0, 180, 0, 1.0)' },
    'colour-orange': { color: 'rgba(255, 127, 0, 1.0)' },
    'colour-yellow': { color: 'rgba(180, 180, 0, 1.0)' }
  };

  blockStyleFn(block) {
    if (block.getType() === 'group-container') {
      return 'group-container';
    }

    // Mark text-empty blocks so CSS can collapse spacers adjacent to hidden
    // groups in live mode without affecting blocks that carry form controls.
    if (!block.getText().trim()) {
      return 'block-empty';
    }
  }

  @bind
  blockRendererFn(block) {
    let type = block.getType();

    if (type === 'group-container') {
      let entityKey = block.getEntityAt(0);
      if (!(entityKey > 0)) {
        return;
      }
      let entity = Entity.get(entityKey);
      if (!entity || entity.getType() !== 'Group') {
        return;
      }
      let data = entity.getData() || {};
      return {
        component: Group,
        editable: true,
        props: {
          key: entityKey,
          store: this.props.store,
          attributes: data
        }
      };
    }
  }
}

export default DraftBase;
